/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestUsers_requestDeleteRequestUser } from '../models/api_requestUsers_requestDeleteRequestUser';
import type { api_requestUsers_requestGetRequestUsers } from '../models/api_requestUsers_requestGetRequestUsers';
import type { api_requestUsers_requestSaveOrganizationRequestUser } from '../models/api_requestUsers_requestSaveOrganizationRequestUser';
import type { api_requestUsers_requestSaveRequestUser } from '../models/api_requestUsers_requestSaveRequestUser';
import type { api_requestUsers_requestUpdateRequestUser } from '../models/api_requestUsers_requestUpdateRequestUser';
import type { api_requestUsers_requestUploadImage } from '../models/api_requestUsers_requestUploadImage';
import type { api_requestUsers_responseDeleteRequestUser } from '../models/api_requestUsers_responseDeleteRequestUser';
import type { api_requestUsers_responseGetJobTypeList } from '../models/api_requestUsers_responseGetJobTypeList';
import type { api_requestUsers_responseGetRequestUsers } from '../models/api_requestUsers_responseGetRequestUsers';
import type { api_requestUsers_responseSaveOrganizationRequestUser } from '../models/api_requestUsers_responseSaveOrganizationRequestUser';
import type { api_requestUsers_responseSaveRequestUser } from '../models/api_requestUsers_responseSaveRequestUser';
import type { api_requestUsers_responseUpdateRequestUser } from '../models/api_requestUsers_responseUpdateRequestUser';
import type { api_requestUsers_responseUploadImage } from '../models/api_requestUsers_responseUploadImage';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestUserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Update RequestUser
     * Update RequestUser
     * @returns api_requestUsers_responseUpdateRequestUser responseUpdateRequestUser
     * @throws ApiError
     */
    public postRequestUserUpdate({
        body,
    }: {
        /**
         * requestUpdateRequestUser
         */
        body: api_requestUsers_requestUpdateRequestUser,
    }): CancelablePromise<api_requestUsers_responseUpdateRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user/update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Image(jpeg or png) from request user
     * Upload Image(jpeg or png) from request user
     * @returns api_requestUsers_responseUploadImage responseUploadImage
     * @throws ApiError
     */
    public postRequestUserUploadImage({
        body,
    }: {
        /**
         * requestUploadImage
         */
        body: api_requestUsers_requestUploadImage,
    }): CancelablePromise<api_requestUsers_responseUploadImage> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user/upload_image',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Organization and RequestUser
     * Create Organization and RequestUser
     * @returns api_requestUsers_responseSaveOrganizationRequestUser responseSaveOrganizationRequestUser
     * @throws ApiError
     */
    public postRequestUsersCreateWithOrganization({
        body,
    }: {
        /**
         * requestSaveOrganizationRequestUser
         */
        body: api_requestUsers_requestSaveOrganizationRequestUser,
    }): CancelablePromise<api_requestUsers_responseSaveOrganizationRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_users/create_with_organization',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete RequestUser
     * Delete RequestUser
     * @returns api_requestUsers_responseDeleteRequestUser responseDeleteRequestUser
     * @throws ApiError
     */
    public postRequestUsersDelete({
        body,
    }: {
        /**
         * requestDeleteRequestUser
         */
        body: api_requestUsers_requestDeleteRequestUser,
    }): CancelablePromise<api_requestUsers_responseDeleteRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_users/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get RequestUser with organization List
     * 組織ID指定時は組織に所属する全利用ユーザー、未指定時はログイン中の利用ユーザーを取得
     * @returns api_requestUsers_responseGetRequestUsers responseGetRequestUsers
     * @throws ApiError
     */
    public postRequestUsersGet({
        body,
    }: {
        /**
         * requestGetRequestUsers
         */
        body: api_requestUsers_requestGetRequestUsers,
    }): CancelablePromise<api_requestUsers_responseGetRequestUsers> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_users/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get JobType List
     * 画面でのプルダウン表示用に、利用ユーザーが選択可能な職業タイプのリストを取得する
     * @returns api_requestUsers_responseGetJobTypeList responseGetJobTypeList
     * @throws ApiError
     */
    public postRequestUsersGetJobTypeList(): CancelablePromise<api_requestUsers_responseGetJobTypeList> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_users/get_job_type_list',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save RequestUser
     * 利用ユーザーを保存する。招待トークンが指定された場合、該当の招待を完了に更新する。
     * @returns api_requestUsers_responseSaveRequestUser responseSaveRequestUser
     * @throws ApiError
     */
    public postRequestUsersSave({
        body,
    }: {
        /**
         * requestSaveRequestUser
         */
        body: api_requestUsers_requestSaveRequestUser,
    }): CancelablePromise<api_requestUsers_responseSaveRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_users/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
